import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'ant-design-vue/dist/antd.less'
import './assets/css/theme.less'
import router from './router'
import '../static/css/global.css'
import axios from 'axios'
import echarts from 'echarts'
import { message } from 'ant-design-vue'
import store from './store'
import { apiListPC } from './api'
import ajax from '@/api/ajax'
import less from 'less'

Vue.prototype.$lock = false
//全局样式变量
import lessVariables from './assets/css/theme.less'
Vue.prototype.globalLess = lessVariables
if (window.config.license !== 'pdf') {
    ajax(apiListPC.getLock + '?code=' + window.config.license + '&type=2').then((res) => {
        Vue.prototype.$lock = res.data == 3 || res.data == 5
    })
}

Vue.use(less)
window.less = less
Vue.prototype.bus = new Vue()
Vue.prototype.$echarts = echarts
Vue.prototype.$message = message

Vue.prototype.$axios = axios
axios.defaults.headers.post['Content-Type'] = 'application/json'
// 添加请求拦截器
axios.interceptors.request.use(
    function (config) {
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        // 一体机不需要token，pc端需要
        if (
            router.currentRoute &&
            router.currentRoute.name &&
            !router.currentRoute.name.includes('Machine')
        ) {
            let res = localStorage.getItem('token')
            config.headers.common['Authentication'] =
                res != undefined && res != 'undefined' && res != '' ? res : ''
        }
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)
// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        //window.console.log(response);  // 对响应数据做点什么
        if (response.headers.authentication) {
            localStorage.setItem('token', response.headers.authentication)
        }
        if (
            response.data.returnInfo === '登录凭证无效' ||
            response.data.returnInfo === '凭证无效' ||
            response.data.returnInfo === '无此访问权限' ||
            response.data.returnInfo === '无效的token'
        ) {
            //说明没有token信息 直接到登录页面
            message.error('请重新登录')
            router.replace('/Login')
        }
        return response
    },
    function (error) {
        if (error.response.data) {
            if (
                error.response.data.returnInfo === '登录凭证无效' ||
                error.response.data.returnInfo === '匿名用户，需要登录' ||
                error.response.data.returnInfo === '无此访问权限' ||
                error.response.data.returnInfo === '无效的token'
            ) {
                //说明没有token信息 直接到登录页面
                message.error('请重新登录')
                router.replace('/Login')
            }
        }
        return Promise.reject(error.response.data)
    }
)
Vue.config.productionTip = false
message.config({
    duration: 2,
    maxCount: 1,
})

Vue.use(Antd)

new Vue({
    render: (h) => h(App),
    router,
    store,
}).$mount('#app')
